// Construction crane icon — matches lucide-react's stroke style
// (currentColor, width/height 24 by default, strokeWidth 2, round joins).
export default function CraneIcon({ size = 24, strokeWidth = 2, className = "", ...rest }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      aria-hidden="true"
      {...rest}
    >
      {/* Vertical tower */}
      <line x1="7" y1="4" x2="7" y2="20" />
      {/* Base / feet */}
      <line x1="4" y1="20" x2="10" y2="20" />
      {/* Horizontal boom (long arm) */}
      <line x1="4" y1="4" x2="21" y2="4" />
      {/* Diagonal counter-jib support */}
      <line x1="4" y1="4" x2="7" y2="7" />
      {/* Diagonal boom support */}
      <line x1="18" y1="4" x2="7" y2="7" />
      {/* Trolley + hook cable */}
      <line x1="18" y1="4" x2="18" y2="10" />
      {/* Hook */}
      <path d="M17 10h2v2h-2z" />
    </svg>
  );
}
